export class UnsavedChangesDetector {
    constructor(form, vdxEventBus = null) {
        this.form = form;
        this.vdxEventBus = vdxEventBus;

        this.initChangeDetection();

        this.form.addEventListener('change', (e) => {
            if (this.formHasChanges()) {
                console.log("form has Changes load");
                window.addEventListener('beforeunload', this.handleUnsavedChangesDetector);
            } else {
                console.log("form doesn't have Changes unload");
                window.removeEventListener('beforeunload', this.handleUnsavedChangesDetector);
            }
        });

        // add a drag n drop listener if there's one on the page
        if (this.vdxEventBus) {
            this.vdxEventBus.on('dnd-in-updated', (e) => {
                console.log("dnd-in-updated adding listener ", e);
                window.addEventListener('beforeunload', this.handleUnsavedChangesDetector);
            });
        }


        if (this.form.btnSave) {
            this.form.btnSave.addEventListener('click', (e) => {
                console.log("Save unload");
                window.removeEventListener('beforeunload', this.handleUnsavedChangesDetector);
            });
        }

        if (this.form.CANCEL) {
            this.form.CANCEL.addEventListener('click', (e) => {
                console.log("Cancel unload");
                window.removeEventListener('beforeunload', this.handleUnsavedChangesDetector);
            });
        }
    }

    handleUnsavedChangesDetector(e) {
        e.returnValue = i18n.common.areYouSure;
    }

    getOrigValueFromFormElement(el) {
        if (el.type === 'checkbox') {
            return el.checked;
        } else if (el.type === 'radio') {
            return this.form[el.name].value;
        }
        return el.value;
    }

    initChangeDetection() {
        Array.from(this.form).forEach(el => {
            el.dataset.origValue = this.getOrigValueFromFormElement(el);
            el.dataset.excludeFromUnsavedChangesDetection = 'false';
        });
    }

    doesFormElementHaveChanges(el, checkedRadioButtons) {
        if (el.dataset.excludeFromUnsavedChangesDetection === 'true') {
            return false;
        } else if (el.type === 'checkbox') {
            return el.dataset.origValue !== el.checked.toString();
        } else if (el.type === 'radio' && checkedRadioButtons.includes(el.name)) {
            return false;
        } else if (el.type === 'radio') {
            checkedRadioButtons.push(el.name);
            return el.dataset.origValue !== this.form[el.name].value;
        } else if (el.type === 'hidden')
            return false;
        return el.dataset.origValue !== el.value;
    }

    formHasChanges() {
        const checkedRadioButtons = [];
        return Array.from(this.form).some(el => {
            return this.doesFormElementHaveChanges(el, checkedRadioButtons);
        });
    }

    remove() {
        console.log("Explicit unload");
        window.removeEventListener('beforeunload', this.handleUnsavedChangesDetector);
    }

    // exclude this form element from the has-change logic
    exclude(el) {
        el.dataset.excludeFromUnsavedChangesDetection = 'true';
    }
}